import { render, staticRenderFns } from "./CohortEditTabInformation.vue?vue&type=template&id=2ba2f5a8&"
import script from "./CohortEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./CohortEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./CohortEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports